import { render, staticRenderFns } from "./SudokuGame.vue?vue&type=template&id=64adda66"
import script from "./SudokuGame.vue?vue&type=script&lang=js"
export * from "./SudokuGame.vue?vue&type=script&lang=js"
import style0 from "./SudokuGame.vue?vue&type=style&index=0&id=64adda66&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports